import React from "react";
import { useVSU } from "../store";

// Статистическая панель (5.8). Четыре карточки по summary. Значения приходят из API —
// клиент их не пересчитывает (в т.ч. не считает длины массивов breakdowns.*).
// Поля summary.addresses_count и without_file приходят, но в этом релизе не выводятся.
export default function StatisticsPanel() {
  const { t, summary } = useVSU();
  const s = summary ?? {
    total: 0,
    sources_count: 0,
    locations_count: 0,
    with_file: 0,
  };

  const cards = [
    { accent: true, n: s.total, l: t("kTotal") },
    { accent: false, n: s.sources_count, l: t("kSrc") },
    { accent: false, n: s.locations_count, l: t("kLoc") },
    { accent: false, n: s.with_file, l: t("kFile") },
  ];

  return (
    <div className="vsu-kpis">
      {cards.map((c, i) => (
        <div key={i} className={"vsu-kpi" + (c.accent ? " accent" : "")}>
          <div className="vsu-kpi-num">{c.n}</div>
          <div className="vsu-kpi-lbl">{c.l}</div>
        </div>
      ))}
    </div>
  );
}
